import { render, staticRenderFns } from "./transferAccount.vue?vue&type=template&id=9828cd1c&scoped=true&"
import script from "./transferAccount.vue?vue&type=script&lang=js&"
export * from "./transferAccount.vue?vue&type=script&lang=js&"
import style0 from "./transferAccount.vue?vue&type=style&index=0&id=9828cd1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9828cd1c",
  null
  
)

export default component.exports